"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var VotingEndedIcon_1 = __importDefault(require("../../../Icons/Notifications/VotingEndedIcon"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "Discover the results"),
            ' ',
            "of the proposal you participated in as a voter. Your input matters!")); },
        title: 'Voting ended on a proposal you voted on'
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "Descubre los resultados"),
            ' ',
            "de la propuesta en la que participaste como votante. Tu opinion es importante!")); },
        title: 'La votacion ha finalizado en una propuesta que votaste'
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u4E86\u89E3\u60A8\u4F5C\u4E3A\u9009\u6C11\u53C2\u4E0E\u7684\u63D0\u6848\u7684\u7ED3\u679C"),
            ". \u60A8\u7684\u610F\u89C1\u5F88\u91CD\u8981\uFF01")); },
        title: '您已投票的提案投票结束'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var GovernanceVotingEndedVoterNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(VotingEndedIcon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" },
            i18N[locale].title,
            ' ',
            react_1.default.createElement("span", { className: "dcl notification-text-highlighted" }, notification.metadata.proposalTitle)),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.link))));
};
exports.default = GovernanceVotingEndedVoterNotification;
